import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  text: FelaCSS;
  buttonWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingBottom: '16px',

    maxWidthTabletSm: {
      paddingTop: '16px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingBottom: '16px',
      backgroundColor: colors.space04,
    },
  },

  text: {
    fontDefault: 22,
    lineHeight: '28px',
    color: colors.space,
    whiteSpace: 'pre-wrap',

    maxWidthTabletSm: {
      fontDefault: 16,
      lineHeight: '20px',
    },
  },

  buttonWrap: {
    alignItems: 'flex-start',
    marginTop: '8px',
  },
});

export default styles;
